import React from "react";
import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

interface BreadcrumbProps {
  isLoading?: boolean;
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ isLoading, items }) => {
  if (isLoading) {
    return (
      <div className="hidden md:flex items-center text-white text-[13px] font-bold leading-[15px] tracking-[0.01em] mb-0">
        <div className="flex items-center gap-2">
          {items.map((_, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span className="mx-2">&gt;</span>}
              <div className="h-4 w-24 bg-white/30 rounded animate-pulse"></div>
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="hidden md:flex items-center text-white text-[13px] font-bold leading-[15px] tracking-[0.01em] mb-0">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isClickable = !isLast && item.url;

        return (
          <React.Fragment key={index}>
            {index > 0 && <span className="mx-2">&gt;</span>}
            {isClickable ? (
              <Link
                to={item.url!}
                className="text-white no-underline hover:underline transition-opacity"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-white opacity-70">{item.label}</span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
